import PropTypes from 'prop-types';
import { responsiveImageType } from './image';

export const videoType = PropTypes.shape({
  height: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
});

export const responsiveVideoType = PropTypes.shape({
  aspect: PropTypes.number.isRequired,
  sizes: PropTypes.arrayOf(videoType).isRequired,
  image: responsiveImageType,
  alternatives: PropTypes.objectOf(PropTypes.shape({
    aspect: PropTypes.number.isRequired,
    image: responsiveImageType,
    sizes: PropTypes.arrayOf(videoType).isRequired,
  })),
});



// WEBPACK FOOTER //
// ./src/propTypes/video.js